type Props = {
  value: number;
};

const numberFormat = (value: number) => new Intl.NumberFormat('de-DE', {
  style: 'currency',
  currency: 'EUR',
}).format(value);

function Preis(props: Props) {
  const { value } = props;
  return (
    <span>{numberFormat(value)}</span>
  );
}

export default Preis;
